import type { MouseEvent, PropsWithChildren } from 'react'
import { forwardRef } from 'react'

import { type PaletteProps } from '@material-ui/system'

import { type IconElement, renderIcon } from '../Icon'
import { TagLabelStyled } from './styles/TagLabelStyled'
import { TagStyled } from './styles/TagStyled'

export interface ITagProps extends PaletteProps {
  icon?: IconElement
  onClick?(e: MouseEvent<HTMLElement>): void
  fullWidth?: boolean
}

export const Tag = forwardRef<HTMLDivElement, PropsWithChildren<ITagProps>>(
  ({ icon, onClick, children, ...props }, ref) => {
    return (
      <TagStyled onClick={onClick} {...props} ref={ref}>
        <TagLabelStyled fullWidth={props.fullWidth}>{children}</TagLabelStyled>
        {renderIcon(icon)}
      </TagStyled>
    )
  }
)

Tag.displayName = 'Tag'
